import React from 'react';
import RouterPaths from '../../../common/RouterPaths';
import BrowserHistory from '../../utils/BrowserHistory';
import { Box, Button, Grid, Icon } from '@amzn/awsui-components-core';
import constants from '../../../common/constants';

const CommunityPageBanner = () => {
  const handleCreateCollection = () => {
    BrowserHistory.push(RouterPaths.CREATE_COLLECTION);
  };

  const handleLearnAboutCollection = () => {
    // redirect to collection post
    const collectionPostLink = '/post-viewer/898b6c3d-fb69-4f00-aaef-8a243d87f4af';
    BrowserHistory.push(collectionPostLink);
  };

  return (
    <div className="custom-home__header banner-bkg bkg-community">
      <Box variant="div" margin={{ left: 'xxs' }} padding={{ top: 'm' }} className="banner-text">
        <div className="custom-home__header-title">
          <Grid
            gridDefinition={[
              { colspan: { default: 11, s: 9, m: 7, l: 6 } },
              { colspan: { default: 1, xxs: 1 } },
            ]}
          >
            <div>
              <Box color="inherit" variant="h2" fontWeight="bold">
                {constants.COLLECTION_DROPDOWN_HEADER}
              </Box>

              <Box variant="p" color="inherit" fontSize="heading-l" className="app-desc">
                {constants.COLLECTION_DESCRIPTION}
              </Box>

              <div className="home-page-banner-action-container">
                <Button variant="primary" onClick={handleCreateCollection}>
                  {constants.CREATE_COLLECTION}
                </Button>
                <Box padding={{ left: 'm' }}>
                  <div
                    onClick={handleLearnAboutCollection}
                    className="home-page-banner-action-link"
                  >
                    {constants.LEARN_ABOUT_COLLECTIONS}{' '}
                    <Icon name="angle-right" size="small" variant="inverted" />
                  </div>
                </Box>
              </div>
            </div>
            <div />
          </Grid>
        </div>
      </Box>
    </div>
  );
};

export default CommunityPageBanner;
